import React from "react";

const MovieCardSkeleton = () => {
  return (
    <div className="relative overflow-hidden rounded-lg bg-gray/20 backdrop-blur-sm border border-white/10 movie-card-wrapper">
      {/* Movie Poster Skeleton */}
      <div className="relative aspect-[2/3] overflow-hidden bg-gradient-to-br from-gray/30 via-gray/20 to-gray/30">
        {/* Shimmer Effect */}
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent animate-shimmer"></div>
        
        {/* Glassy overlay effect */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/40"></div>
      </div>

      {/* Movie Info Skeleton */}
      <div className="p-3 space-y-2">
        <div className="h-4 bg-gray/40 rounded-md w-3/4 backdrop-blur-sm">
          <div className="h-full bg-gradient-to-r from-gray/40 via-white/10 to-gray/40 animate-shimmer"></div>
        </div>
        <div className="h-3 bg-gray/30 rounded-md w-1/2 backdrop-blur-sm">
          <div className="h-full bg-gradient-to-r from-gray/30 via-white/10 to-gray/30 animate-shimmer"></div>
        </div>
      </div>

      {/* Rating Badge Skeleton */}
      <div className="absolute top-3 right-3 bg-black/50 backdrop-blur-md rounded-full px-2.5 py-1 border border-white/10">
        <div className="h-3 w-8 bg-gray/40 rounded-full">
          <div className="h-full bg-gradient-to-r from-gray/40 via-white/10 to-gray/40 rounded-full animate-shimmer"></div>
        </div>
      </div>
    </div>
  );
};

export default MovieCardSkeleton;

